import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PostPageToolbar, PostPageToolbarItemReply, usePostPageToolbarMenu } from "../PostPageToolbar";
import PostPageViewsTodoListToolbarMenu from "./PostPageViewsTodoListToolbarMenu";
const PostPageViewsTodoListToolbar = (props)=>{
    const { todoList  } = props;
    usePostPageToolbarMenu(todoList);
    return /*#__PURE__*/ _jsxs(PostPageToolbar, {
        children: [
            /*#__PURE__*/ _jsx(PostPageToolbarItemReply, {
                itemId: todoList.id
            }),
            /*#__PURE__*/ _jsx(PostPageViewsTodoListToolbarMenu, {
                todoList: todoList
            })
        ]
    });
};
export default PostPageViewsTodoListToolbar;
